import type { FunctionComponent } from "react";
import styles from "./stepped-flow-stepper.module.scss";
import type { IProps } from "./stepped-flow-stepper.types";
import { Stepper } from "../../stepper";

/**
 * The step indicator in a stepped shell's header: one numbered pill per step. Clicking a previous step
 * navigates back; future steps are not clickable.
 */
const SteppedFlowStepper: FunctionComponent<IProps> = ({ active, onStepChange, steps }) => (
    <Stepper
        active={active}
        onStepClick={(step) => {
            if (step < active) {
                onStepChange(step);
            }
        }}
        allowNextStepsSelect={false}
        size="sm"
        className={styles["stepper"]}
    >
        {steps.map((step, index) => (
            <Stepper.Step key={index} label={step.props.label} />
        ))}
    </Stepper>
);

export { SteppedFlowStepper };
